import qs from 'qs'
import { axios } from '@/utils/request'

//申请表单相关Api
const applyApi = {
  getSelectExpertApplyViewList: '/api/1/expertmain/selectExpertApply/get_select_expert_apply_view_list.json',
  addOrEditSelectExpertApply: '/api/1/expertmain/selectExpertApply/add_or_edit_auto_select_expert_apply.json',
  deleteSelectExpertApply: '/api/1/expertmain/selectExpertApply/delete_select_expert_apply.json',
  querySelectExpertApplyList: '/api/1/expertmain/selectExpertApply/querySelectExpertApply',
}

//抽取专家表相关Api
const extractExpertApi = {
  confirmExpertFlag: '/api/1/expertmain/extractExpert/confirmExpertFlag',
  extractExpert: '/api/1/expertmain/selectExpertApply/extractExpert',
  redrawExpert: '/api/1/expertmain/selectExpertApply/redrawExpert',
  autoRedrawExpert: '/api/1/expertmain/selectExpertApply/autoRedrawExpert',
  selectRedrawExtractItem: '/api/1/expertmain/selectExpertApply/selectRedrawExtractItem',
  appointSelectExtractItem: '/api/1/expertmain/selectExpertApply/appointSelectExtractItem',
  appointExtractExpert: '/api/1/expertmain/selectExpertApply/appointExtractExpert',
  extractExpertDecrypt: '/api/1/expertmain/selectExpertApply/extractExpertDecrypt',
  pushExtractExpert: '/api/1/expertmain/selectExpertApply/pushExtractExpert',
  exportExtractExpertDoc: '/api/1/expertmain/selectExpertApply/exportExtractExpertDoc',
  exportExtractExpert: '/api/1/expertmain/selectExpertApply//exportExtractExpert',
  reSendExpertSms: '/api/1/expertmain/extractExpert/reSendExpertSms',
  replaceExtractExpert: '/api/1/expertmain/selectExpertApply/replaceExtractExpert',
  getExpertLeaveList: '/api/1/expertmain/extractExpert/getExpertLeaveList',
}
//抽取专家语音发送Api
const expertIvrApi = {
  sendSingleIvrCall: '/api/1/expertmain/extractExpert/sendSingleIvrCall',
  sendBatchIvrCall: '/api/1/expertmain/extractExpert/sendBatchIvrCall',
}

//构建请求
/**
 * 获取申请页面所有数据
 * @param id
 * @param decryptFlag
 * @returns {AxiosPromise<any>}
 */
export const GetSelectExpertApplyList = (id, forceDecryptFlag) => axios.get(applyApi.getSelectExpertApplyViewList, {
  params: {
    id,
    forceDecryptFlag
  }
})
/**
 * 添加专家申请信息
 * @param apply
 * @returns {AxiosPromise<any>}
 */
export const AddOrEditSelectExpertApply = (apply) => axios.post(applyApi.addOrEditSelectExpertApply, qs.stringify(apply, { allowDots: true }))
/**
 * 添加专家申请信息
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const DeleteSelectExpertApply = (id) => axios.post(applyApi.deleteSelectExpertApply, qs.stringify({ id: id }))

export const QuerySelectExpertApplyList = (data) => axios.get(applyApi.querySelectExpertApplyList, { params: { ...data } })

/**
 *  补抽专家
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const RedrawExpert = (data) => axios.post(extractExpertApi.redrawExpert, qs.stringify(data, { allowDots: true }))

/**
 *  自动补抽专家
 * @param data
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const AutoRedrawExpert = (data) => axios.post(extractExpertApi.autoRedrawExpert, qs.stringify(data))

/**
 * 手工抽专家
 * @param id
 * @returns {AxiosPromise<any>}
 */
export const ExtractExpert = (id) => axios.post(extractExpertApi.extractExpert, qs.stringify({ id: id }))
/**
 * 指定抽专家
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const AppointExtractExpert = (data) => axios.post(extractExpertApi.appointExtractExpert, qs.stringify(data, { allowDots: true }))
/**
 * 指定抽和补抽专家之前弹框现在品目
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const SelectRedrawExtractItem = (data) => axios.post(extractExpertApi.selectRedrawExtractItem, qs.stringify(data))

/**
 * 替换专家
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const ReplaceExtractExpert = (data) => axios.post(extractExpertApi.replaceExtractExpert, qs.stringify(data))

/**
 * 电话请假专家列表
 * @returns {AxiosPromise<any>}
 * @param data
 */
export const GetExpertLeaveList = (data) => axios.get(extractExpertApi.getExpertLeaveList, { params: { ...data } })

/**
 * 推送专家信息到快采
 * @param id 申请单id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const PushExtractExpert = (id) => axios.post(extractExpertApi.pushExtractExpert, qs.stringify({ id: id }))

/**
 * 解密专家列表
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param applyId
 * @param pushFlag 是否推送到采购平台
 */
export const ExtractExpertDecrypt = (applyId, pushFlag) => axios.post(extractExpertApi.extractExpertDecrypt, qs.stringify({
  applyId: applyId,
  pushFlag: pushFlag
}))

/**
 * 手工设置专家状态
 * @returns {AxiosPromise<any>}
 * @constructor
 * @param data
 */
export const ConfirmExpertFlag = (data) => axios.post(extractExpertApi.confirmExpertFlag, qs.stringify(data))

/**
 * 重发专家短信
 * @param id 专家id
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const ReSendExpertSms = (id) => axios.post(extractExpertApi.reSendExpertSms, qs.stringify({ id: id }))

/**
 * 发送单个语音
 * @param form
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SendSingleIvrCall = (form) => axios.post(expertIvrApi.sendSingleIvrCall, qs.stringify(form))

/**
 * 发送批量语音
 * @param form
 * @returns {AxiosPromise<any>}
 * @constructor
 */
export const SendBatchIvrCall = (form) => axios.post(expertIvrApi.sendBatchIvrCall, form)
